/* ==========================================================================
   Voltaire Amsterdam — Produktseite
   - Galerie (Swipe, Pfeile, Thumbnails, Vollbild)
   - Bundle-Konfigurator (1/2/3 BHs, Farbe/Größe je BH, EU-Größenfinder, Gratisartikel)
   - Einfache Variantenauswahl für Accessoires
   - Größenberater-Dialog, Sticky-Button, Banner-Countdown, Kundenvideos
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-section]');
  var dataEl = document.querySelector('[data-product-json]');
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = DATA.product;
  var C = window.VoltaireCart;
  var esc = function (v) { return C ? C.esc(v) : String(v); };
  var money = function (c) { return C ? C.money(c) : (c / 100).toFixed(2) + ' €'; };
  var cfg = (C && C.config) || {};

  var ci = P.colorIndex;
  var si = P.sizeIndex;

  // Größen sinnvoll sortieren (Shopify liefert sie alphabetisch: 2XL, 3XL, L, M ...)
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL', '4XL', '5XL', 'One Size'];
  P.sizes = P.sizes.slice().sort(function (a, b) {
    var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
    if (ia === -1 && ib === -1) return 0;
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });
  // Bevorzugte Farbreihenfolge je Modell (wie auf der Lovable-Website)
  var PREFERRED_COLORS = {
    '15677919134020': ['Brown leopard print', 'Pink leopard print'],
    '15708627042628': ['Brown leopard print', 'Pink leopard print'],
    '15677909270852': ['Leopad-Black'],
    '15677909631300': ['Pink'],
    '15677911138628': ['Purple']
  };
  var pref = PREFERRED_COLORS[String(P.id)] || [];
  P.colors = P.colors.slice().sort(function (a, b) {
    var ia = pref.indexOf(a.value), ib = pref.indexOf(b.value);
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
  });
  var MAX_SLOTS = 3;

  /* ---------- Varianten-Helfer ---------- */
  function variantFor(color, size) {
    for (var i = 0; i < P.variants.length; i++) {
      var v = P.variants[i];
      if ((ci < 0 || v.options[ci] === color) && (si < 0 || v.options[si] === size)) return v;
    }
    return null;
  }
  function avail(color, size) { var v = variantFor(color, size); return !!(v && v.available); }
  function colorAvailable(color) {
    if (si < 0) return avail(color, null);
    return P.sizes.some(function (s) { return avail(color, s); });
  }
  function colorObj(value) {
    for (var i = 0; i < P.colors.length; i++) if (P.colors[i].value === value) return P.colors[i];
    return { value: value, name: value, swatch: '#ddd', image: null };
  }
  function colorLabel(value) { return colorObj(value).name || value; }
  function colorImage(value) {
    var c = colorObj(value);
    if (c.image) return c.image;
    var v = P.variants.filter(function (x) { return ci >= 0 && x.options[ci] === value && x.image; })[0];
    return (v && v.image) || P.image;
  }
  function priceFor(color, size) {
    var v = variantFor(color, size);
    if (v) return v.price;
    return Math.min.apply(null, P.variants.map(function (x) { return x.price; }));
  }
  function slugify(value) {
    return String(value || '').toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  /* ---------- EU-Größenmatrix ---------- */
  var CUP_ORDER = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
  var matrix = {};
  if (P.matrix) {
    Object.keys(P.matrix).forEach(function (band) {
      Object.keys(P.matrix[band]).forEach(function (cup) {
        var size = P.matrix[band][cup];
        if (P.sizes.indexOf(size) === -1) return;
        (matrix[band] = matrix[band] || {})[cup] = size;
      });
    });
  }
  var hasMatrix = Object.keys(matrix).length > 0;
  function bands() { return Object.keys(matrix).map(Number).sort(function (a, b) { return a - b; }); }
  function cupsFor(band) {
    return Object.keys(matrix[band] || {}).sort(function (a, b) { return CUP_ORDER.indexOf(a) - CUP_ORDER.indexOf(b); });
  }
  function lookup(band, cup) { return (matrix[band] && matrix[band][cup]) || null; }

  /* ---------- Zustand ---------- */
  var mode = DATA.isBra && si >= 0 ? 'bundle' : 'single';
  var state = {
    color: null,
    size: '',
    fit: { band: '', cup: '' },
    count: mode === 'bundle' ? Math.min(MAX_SLOTS, Math.max(1, DATA.defaultCount || 2)) : 1,
    slots: [],
    open: {},
    added: false,
    braCountInCart: 0,
    options: []
  };
  function emptySlot() { return { auto: true, color: '', size: '', band: '', cup: '', note: '' }; }
  for (var k = 0; k < MAX_SLOTS - 1; k++) state.slots.push(emptySlot());

  (function initSelection() {
    var requested = new URLSearchParams(window.location.search).get('color');
    var wanted = slugify(requested);
    var match = null;
    if (wanted && ci >= 0) {
      match = P.colors.filter(function (c) { return slugify(c.name) === wanted || slugify(c.value) === wanted; })[0];
    }
    var firstAvailable = P.colors.filter(function (c) { return colorAvailable(c.value); })[0];
    state.color = match ? match.value : (firstAvailable ? firstAvailable.value : (P.colors[0] && P.colors[0].value) || null);
    if (si >= 0) {
      var preferred = P.sizes[Math.min(1, P.sizes.length - 1)];
      state.size = avail(state.color, preferred) ? preferred : (P.sizes.filter(function (s) { return avail(state.color, s); })[0] || '');
    }
    // Einfache Produkte: Auswahl aus der ersten verfügbaren Variante
    var start = P.variants.filter(function (v) { return v.available; })[0] || P.variants[0];
    state.options = start ? start.options.slice() : [];
    if (ci >= 0 && state.color) state.options[ci] = state.color;
    state.fromUrl = !!match;
  })();

  function resolveSlot(slot) {
    if (slot.auto) return { color: state.color, size: state.size, band: state.fit.band, cup: state.fit.cup, auto: true, note: '' };
    return slot;
  }
  function allSlots() {
    var list = [{ color: state.color, size: state.size, first: true }];
    for (var i = 0; i < state.count - 1; i++) list.push(resolveSlot(state.slots[i]));
    return list;
  }
  function freezeAutos() {
    state.slots = state.slots.map(function (s) {
      return s.auto ? { auto: false, color: state.color, size: state.size, band: state.fit.band, cup: state.fit.cup, note: '' } : s;
    });
  }
  function slotComplete(s) { return !!(s.color && s.size && !s.note && avail(s.color, s.size)); }

  function applyTopSize(next, fit) {
    state.size = next;
    state.slots = state.slots.map(function (s, i) {
      if (s.auto || !next) return s;
      var n = { auto: false, color: s.color, size: s.size, band: fit ? String(fit.band) : s.band, cup: fit ? fit.cup : s.cup, note: '' };
      if (s.color && avail(s.color, next)) { n.size = next; }
      else { n.size = ''; n.note = 'Diese Größe ist leider nicht verfügbar.'; }
      return n;
    });
  }
  function applyTopFit(fit) {
    state.fit = fit;
    var complete = fit.band && fit.cup;
    if (!complete) state.size = '';
    state.slots = state.slots.map(function (s, i) {
      if (s.auto) return s;
      var mapped = complete ? lookup(fit.band, fit.cup) : null;
      var ok = !!(mapped && s.color && avail(s.color, mapped));
      return {
        auto: false, color: s.color, band: fit.band, cup: fit.cup,
        size: ok ? mapped : '',
        note: complete && mapped && !ok ? 'Diese Größe ist leider nicht verfügbar.'
          : complete && !mapped ? 'Für BH ' + (i + 2) + ' gibt es keine passende Größe. Bitte wählen Sie eine gültige Größe.' : ''
      };
    });
  }

  function rateFor(count) {
    if (count >= 3) return cfg.rate3 || 0;
    if (count === 2) return cfg.rate2 || 0;
    return 0;
  }
  function amounts(prices, rate) {
    var subtotal = prices.reduce(function (s, p) { return s + p; }, 0);
    var total = subtotal - Math.floor(subtotal * rate + 1e-6);
    return { subtotal: subtotal, total: total, saving: subtotal - total };
  }
  function giftsFor(count) { return C ? C.giftsFor(count) : []; }

  /* ---------- Rendering: Bausteine ---------- */
  function swatchesHtml() {
    if (ci < 0 || !P.colors.length) return '';
    var html = '<div><p class="cfg-label"><strong>Farbe:</strong> <span>' + esc(colorLabel(state.color)) + '</span></p>' +
      '<div class="swatches no-scrollbar" role="radiogroup" aria-label="Farbe wählen">';
    P.colors.forEach(function (c) {
      var soldOut = !colorAvailable(c.value);
      var sel = c.value === state.color;
      var img = colorImage(c.value);
      html += '<button type="button" class="swatch" role="radio" aria-checked="' + sel + '" aria-label="' + esc(c.name + (soldOut ? ' – ausverkauft' : '')) + '" data-color="' + esc(c.value) + '"' + (soldOut ? ' disabled' : '') + '>' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="swatch__dot" style="background:' + esc(c.swatch) + '"></span>') +
        '</button>';
    });
    return html + '</div></div>';
  }

  function sizeSelectHtml(color, size, attrs, small) {
    var html = '<select class="cfg-select select' + (small ? ' cfg-select--sm' : '') + '" ' + attrs + (color ? '' : ' disabled') + '>';
    if (!size) html += '<option value="" disabled selected>Größe</option>';
    P.sizes.forEach(function (s) {
      var ok = avail(color, s);
      html += '<option value="' + esc(s) + '"' + (s === size ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + esc(s) + (ok ? '' : ' – ausverkauft') + '</option>';
    });
    return html + '</select>';
  }

  function finderHtml(opts) {
    // opts: { prefix, label, color, size, band, cup, compact, slot }
    var suffix = opts.label ? ' für ' + opts.label : '';
    var data = opts.slot != null ? ' data-slot="' + opts.slot + '"' : '';
    var small = !!opts.compact;
    var cls = 'cfg-select select' + (small ? ' cfg-select--sm' : '');
    var bandHtml = '<select class="' + cls + '" aria-label="Umfang' + esc(suffix) + '" data-band' + data + (hasMatrix ? '' : ' disabled') + '><option value="">–</option>';
    bands().forEach(function (b) { bandHtml += '<option value="' + b + '"' + (String(b) === String(opts.band) ? ' selected' : '') + '>' + b + '</option>'; });
    bandHtml += '</select>';
    var cupHtml = '<select class="' + cls + '" aria-label="Cup' + esc(suffix) + '" data-cup' + data + (opts.band ? '' : ' disabled') + '><option value="">–</option>';
    (opts.band ? cupsFor(opts.band) : []).forEach(function (c) { cupHtml += '<option value="' + c + '"' + (c === opts.cup ? ' selected' : '') + '>' + c + '</option>'; });
    cupHtml += '</select>';
    var recommended = opts.band && opts.cup ? lookup(opts.band, opts.cup) : null;
    var html = '<div class="size-finder">' +
      '<label><span class="size-finder__cap">Umfang</span>' + bandHtml + '</label>' +
      '<span class="size-finder__op" aria-hidden="true">+</span>' +
      '<label><span class="size-finder__cap">Cup</span>' + cupHtml + '</label>' +
      '<span class="size-finder__op" aria-hidden="true">=</span>' +
      '<label><span class="size-finder__cap">' + (!opts.compact && !recommended ? 'Größe' : 'Empfohlen') + '</span>' +
        sizeSelectHtml(opts.color, opts.size, 'aria-label="Größe' + esc(suffix) + '" data-size-select' + data, small) + '</label>' +
      '</div>';
    if (!hasMatrix) html += '<p class="size-note" role="status">Bitte prüfen Sie unsere Größentabelle.</p>';
    if (recommended && !avail(opts.color, recommended)) html += '<p class="size-note" role="status">Größe ' + esc(recommended) + ' ist in dieser Farbe ausverkauft.</p>';
    if (recommended && opts.size && opts.size !== recommended && avail(opts.color, recommended)) html += '<p class="size-note" role="status">Empfohlen: ' + esc(recommended) + ' · Sie haben ' + esc(opts.size) + ' gewählt.</p>';
    return html;
  }

  function mainSizeHtml() {
    if (si < 0) return '';
    var recommended = state.fit.band && state.fit.cup ? lookup(state.fit.band, state.fit.cup) : null;
    var help = recommended
      ? 'Ihre Empfehlung laut Größentabelle: ' + esc(recommended) + '.'
      : 'Umfang + Cup eingeben für Ihre Größenempfehlung – oder rechts direkt Ihre Größe wählen.' + (state.size ? ' Vorauswahl: ' + esc(state.size) + '.' : '');
    return '<div data-field="size-main">' +
      '<div class="cfg-size-head"><p>Größe</p><button type="button" class="modal-trigger" data-open-size-guide>Finden Sie Ihre perfekte Größe</button></div>' +
      '<p class="cfg-size-help">' + help + (DATA.sizeAdvisorUrl ? ' <a class="text-link" href="' + esc(DATA.sizeAdvisorUrl) + '">Größenberater</a>' : '') + '</p>' +
      (hasMatrix ? finderHtml({ color: state.color, size: state.size, band: state.fit.band, cup: state.fit.cup }) :
        '<div style="margin-top:.375rem">' + sizeSelectHtml(state.color, state.size, 'aria-label="Größe" data-size-select') + '</div>') +
      '</div>';
  }

  function slotHtml(slot, index) {
    var imgSrc = colorImage(slot.color || state.color);
    var img = '<img class="slot__img" src="' + esc(imgSrc) + '" alt="" width="44" height="44" loading="lazy">';
    if (slot.first) {
      return '<li class="slot" data-field="slot-0"><div class="slot__row">' + img +
        '<span class="slot__text"><strong>BH 1 · ' + esc(colorLabel(slot.color)) + ' · ' + esc(slot.size || 'Größe offen') + '</strong>' +
        '<a href="#farbe-groesse">Oben ändern</a></span></div></li>';
    }
    var n = index + 1;
    var complete = slotComplete(slot);
    if (complete && !state.open[index]) {
      return '<li class="slot" data-field="slot-' + index + '"><div class="slot__row">' + img +
        '<span class="slot__text"><strong>BH ' + n + ' · ' + esc(colorLabel(slot.color)) + ' · ' + esc(slot.size) + '</strong>' +
        (slot.auto ? '<small>Wie BH 1</small>' : '') + '</span>' +
        '<button type="button" class="slot__btn" aria-label="BH ' + n + ' ändern" data-slot-open="' + index + '">Ändern</button></div></li>';
    }
    var colorSel = '<select class="cfg-select select" aria-label="Farbe für BH ' + n + '" data-slot-color="' + (index - 1) + '">';
    if (!slot.color) colorSel += '<option value="" disabled selected>Farbe wählen</option>';
    P.colors.forEach(function (c) {
      colorSel += '<option value="' + esc(c.value) + '"' + (c.value === slot.color ? ' selected' : '') + (colorAvailable(c.value) ? '' : ' disabled') + '>' + esc(c.name) + '</option>';
    });
    colorSel += '</select>';
    var html = '<li class="slot" data-field="slot-' + index + '"><div class="slot__row">' + img + '<div class="slot__selects">' + colorSel + '</div></div>';
    html += '<div style="margin-top:.375rem">' + (hasMatrix
      ? finderHtml({ label: 'BH ' + n, color: slot.color, size: slot.size, band: slot.band, cup: slot.cup, compact: true, slot: index - 1 })
      : sizeSelectHtml(slot.color, slot.size, 'aria-label="Größe für BH ' + n + '" data-size-select data-slot="' + (index - 1) + '"', true)) + '</div>';
    if (slot.note) html += '<p class="slot__error" role="alert">' + esc(slot.note) + '</p>';
    if (!complete) html += '<p class="slot__error" role="status">Bitte Farbe und Größe für BH ' + n + ' wählen.</p>';
    if (complete && state.open[index]) html += '<button type="button" class="slot__done" data-slot-done="' + index + '">Fertig</button>';
    return html + '</li>';
  }

  // Eine Auswahl je Farbe: jeweils die erste verfügbare Variante (z. B. Cup A bei den Nippel-Covers)
  function giftColors(g) {
    var seen = {};
    return (g.variants || []).filter(function (v) {
      if (!v.available || seen[v.color]) return false;
      seen[v.color] = true; return true;
    });
  }
  function giftPickerHtml(count) {
    var gifts = giftsFor(count).filter(function (g) { return giftColors(g).length > 1; });
    if (!gifts.length) return '';
    var html = '<div class="gift-picker" data-field="gifts">';
    gifts.forEach(function (g) {
      var chosen = C.giftChoice(g);
      html += '<div class="gift-picker__group"><p class="gift-picker__title">' +
        '<svg class="icon icon--sm icon--sage" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/></svg>' +
        esc(g.label) + (chosen ? ' · <span class="muted" style="font-weight:400">' + esc(chosen.color) + '</span>' : '') + '</p>' +
        '<div class="gift-picker__choices" role="radiogroup" aria-label="Farbe für ' + esc(g.title) + '">';
      giftColors(g).forEach(function (v) {
        var sel = chosen && chosen.color === v.color;
        html += '<button type="button" class="gift-choice" role="radio" aria-checked="' + !!sel + '" data-gift-choice="' + esc(g.handle) + '" data-variant="' + v.id + '" title="' + esc(v.color) + '">' +
          '<span class="gift-choice__dot" style="background:' + esc(v.swatch) + '"></span>' + esc(v.color) + '</button>';
      });
      html += '</div></div>';
    });
    return html + '</div>';
  }

  function giftBarsHtml(count) {
    var gifts = giftsFor(count);
    if (!gifts.length) return '';
    var html = '<div class="gift-bars">';
    gifts.forEach(function (g) {
      html += '<div class="gift-bar">' +
        (g.image ? '<img src="' + esc(g.image) + '" alt="" width="32" height="32" loading="lazy">' : '') +
        '<span class="gift-bar__name">' + esc(g.label.replace(/^Gratis\s+/i, '')) + '</span>' +
        '<span style="display:flex;align-items:center;gap:.375rem;flex-shrink:0"><span class="gift-bar__tag">Gratis</span>' +
        (g.price ? '<span class="gift-bar__old">' + money(g.price) + '</span>' : '') + '</span></div>';
    });
    return html + '</div>';
  }

  function tierHtml(count) {
    var selected = state.count === count;
    var rate = rateFor(count);
    var slots = [{ color: state.color, size: state.size }];
    for (var i = 0; i < count - 1; i++) slots.push(resolveSlot(state.slots[i]));
    var prices = slots.map(function (s) { return s.color && s.size ? priceFor(s.color, s.size) : null; });
    var complete = prices.every(function (p) { return p !== null; });
    var display = slots.map(function (s) { return s.color && s.size ? priceFor(s.color, s.size) : priceFor(s.color || state.color, null); });
    var a = amounts(display, rate);
    var unitOld = display.reduce(function (s, p) { return s + p; }, 0) / count;
    var unit = a.total / count;
    var badge = count === 2 ? 'Am beliebtesten' : count === 3 ? 'Bestes Angebot' : '';
    var title = count === 1 ? 'Einzelkauf' : count + ' BHs kaufen';
    var priceHtml = count === 1
      ? '<span class="tier__unit tier__unit--plain" style="display:block">' + money(a.total) + '</span>'
      : '<span class="tier__price-row">' + (rate > 0 ? '<span class="tier__unit-old">' + money(Math.round(unitOld)) + '</span>' : '') +
        '<span class="tier__unit">' + (complete ? '' : 'ab ') + money(Math.round(unit)) + '</span></span>' +
        '<span class="tier__per">pro BH</span><span class="tier__total">Gesamt ' + money(a.total) + '</span>';
    var html = '<section class="tier' + (badge ? ' tier--badge' : '') + (selected ? ' is-selected' : '') + '">' +
      (badge ? '<span class="tier__badge">' + badge + '</span>' : '') +
      '<button type="button" class="tier__head" role="radio" aria-checked="' + selected + '" aria-expanded="' + selected + '" data-tier="' + count + '">' +
        '<span class="tier__radio"></span>' +
        '<span class="tier__title"><strong>' + title + '</strong>' + (rate > 0 ? '<span>' + Math.round(rate * 100) + ' % Rabatt</span>' : '') + '</span>' +
        '<span class="tier__price">' + priceHtml + '</span>' +
      '</button>';
    if (selected) {
      html += '<div class="tier__body"><ul class="slots">' + allSlots().map(slotHtml).join('') + '</ul>' + giftPickerHtml(count) + '</div>';
    }
    return html + giftBarsHtml(count) + '</section>';
  }

  function summaryHtml() {
    var slots = allSlots();
    var prices = slots.map(function (s) { return s.color && s.size ? priceFor(s.color, s.size) : null; });
    var complete = prices.every(function (p) { return p !== null; });
    if (!complete) {
      return '<div class="price-summary" aria-live="polite"><div class="price-summary__row"><span style="font-weight:600">Gesamtpreis</span><span class="muted">Auswahl offen</span></div></div>';
    }
    var a = amounts(prices, rateFor(state.count));
    var giftValue = state.count > 1 ? giftsFor(state.count).reduce(function (s, g) { return s + (g.price || 0); }, 0) : 0;
    var advantage = a.saving + giftValue;
    var html = '<div class="price-summary" aria-live="polite"><dl>';
    if (advantage > 0) {
      html += '<div class="price-summary__row price-summary__regular"><dt>Regulärer Gesamtwert</dt><dd>' + money(a.subtotal + giftValue) + '</dd></div>' +
        '<div class="price-summary__row price-summary__save"><dt>Ihr Gesamtvorteil</dt><dd>' + money(advantage) + '</dd></div>';
    }
    html += '<div class="price-summary__row price-summary__total"><dt>Gesamtpreis</dt><dd>' + money(a.total) + '</dd></div></dl></div>';
    return html;
  }

  function addButtonHtml(available) {
    return '<div class="purchase"><button type="button" class="btn btn--dark btn--lg btn--block" data-add' + (!available || state.added ? ' disabled' : '') + ' aria-live="polite">' +
      (state.added ? '✓ Hinzugefügt' : available ? 'In den Warenkorb' : 'Ausverkauft') + '</button></div>';
  }

  function renderBundle() {
    var html = '<div id="farbe-groesse" style="scroll-margin-top:8rem;display:grid;gap:1rem">' + swatchesHtml() + mainSizeHtml() + '</div>';
    html += '<div class="bundle-head"><div><p class="eyebrow">Voltaire Bundle</p><h2>Im Set sparen</h2></div>' +
      '<p class="bundle-head__note">Farben und Größen frei kombinieren</p></div>';
    html += '<div class="tiers" role="radiogroup" aria-label="Set-Größe wählen">' + [1, 2, 3].map(tierHtml).join('') + '</div>';
    if (state.braCountInCart > 0) {
      html += '<p class="size-note" style="margin-top:.5rem">Ihre ' + state.braCountInCart + ' bereits gewählten BH' + (state.braCountInCart === 1 ? '' : 's') + ' zählen für den Rabatt mit.</p>';
    }
    html += summaryHtml();
    html += addButtonHtml(state.color ? colorAvailable(state.color) : true);
    return html;
  }

  /* ---------- Einfache Produkte ---------- */
  function currentSingleVariant() {
    for (var i = 0; i < P.variants.length; i++) {
      var v = P.variants[i];
      if (v.options.every(function (o, idx) { return o === state.options[idx]; })) return v;
    }
    return null;
  }
  function renderSingle() {
    var html = '<div style="display:grid;gap:1rem">';
    P.options.forEach(function (name, idx) {
      if (P.options.length === 1 && name === 'Title') return;
      var values = [];
      P.variants.forEach(function (v) { if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]); });
      if (idx === ci) {
        html += swatchesHtml();
        return;
      }
      html += '<div><p class="cfg-label"><strong>' + esc(name) + ':</strong> ' + esc(state.options[idx] || '') + '</p><div class="size-buttons" role="radiogroup" aria-label="' + esc(name) + '">';
      values.forEach(function (val) {
        var test = state.options.slice(); test[idx] = val;
        var ok = P.variants.some(function (v) { return v.available && v.options.every(function (o, j) { return o === test[j]; }); });
        html += '<button type="button" class="size-btn" role="radio" aria-checked="' + (state.options[idx] === val) + '" data-option="' + idx + '" data-value="' + esc(val) + '"' + (ok ? '' : ' disabled') + '>' + esc(val) + '</button>';
      });
      html += '</div></div>';
    });
    html += '</div>';
    var v = currentSingleVariant();
    html += addButtonHtml(!!(v && v.available));
    return html;
  }

  /* ---------- Render & Updates ---------- */
  var container = root.querySelector('[data-configurator]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');

  function updatePriceRow() {
    var v = mode === 'bundle' ? variantFor(state.color, state.size) : currentSingleVariant();
    if (!v) return;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      compareEl.hidden = !(v.compare > v.price);
      compareEl.textContent = v.compare > v.price ? money(v.compare) : '';
    }
  }

  function render() {
    if (!container) return;
    var active = document.activeElement;
    var focusKey = null;
    if (active && container.contains(active)) {
      focusKey = ['data-color', 'data-tier', 'data-band', 'data-cup', 'data-size-select', 'data-slot-color', 'data-option', 'data-gift-choice', 'data-slot-open', 'data-add']
        .filter(function (a) { return active.hasAttribute(a); })
        .map(function (a) {
          var sel = '[' + a + (active.getAttribute(a) ? '="' + active.getAttribute(a).replace(/"/g, '\\"') + '"' : '') + ']';
          if (active.hasAttribute('data-slot')) sel += '[data-slot="' + active.getAttribute('data-slot') + '"]';
          if (active.hasAttribute('data-value')) sel += '[data-value="' + active.getAttribute('data-value').replace(/"/g, '\\"') + '"]';
          if (active.hasAttribute('data-variant')) sel += '[data-variant="' + active.getAttribute('data-variant') + '"]';
          return sel;
        })[0] || null;
    }
    container.innerHTML = mode === 'bundle' ? renderBundle() : renderSingle();
    if (focusKey) {
      try { var el = container.querySelector(focusKey); if (el) el.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
    updatePriceRow();
    updateSticky();
  }

  function scrollToField(key, message) {
    var field = container.querySelector('[data-field="' + key + '"]') || container;
    var header = document.querySelector('[data-header]');
    var offset = (header ? header.getBoundingClientRect().bottom : 0) + 16;
    window.scrollTo({ top: window.scrollY + field.getBoundingClientRect().top - offset, behavior: 'smooth' });
    setTimeout(function () { var f = field.querySelector('select,button'); if (f) f.focus({ preventScroll: true }); }, 400);
    if (message && C) C.toast(message, null, 'error');
  }

  function validatedItems() {
    var slots = allSlots();
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var n = i + 1;
      if (!s.color && ci >= 0) { state.open[i] = true; render(); scrollToField('slot-' + i, 'Bitte wählen Sie eine Farbe für BH ' + n + '.'); return null; }
      if (!s.size && si >= 0) { state.open[i] = true; render(); scrollToField(i === 0 ? 'size-main' : 'slot-' + i, 'Bitte wählen Sie eine Größe für BH ' + n + '.'); return null; }
      if (!avail(s.color, s.size)) { state.open[i] = true; render(); scrollToField(i === 0 ? 'size-main' : 'slot-' + i, 'Diese Variante für BH ' + n + ' ist nicht verfügbar.'); return null; }
    }
    var grouped = {};
    var order = [];
    slots.forEach(function (s) {
      var v = variantFor(s.color, s.size);
      if (!grouped[v.id]) { grouped[v.id] = 0; order.push(v.id); }
      grouped[v.id] += 1;
    });
    return order.map(function (id) { return { id: id, quantity: grouped[id], productId: P.id }; });
  }

  var addLock = false;
  function handleAdd() {
    if (addLock || !C) return;
    var items;
    if (mode === 'bundle') {
      items = validatedItems();
    } else {
      var v = currentSingleVariant();
      if (!v || !v.available) { C.toast('Diese Kombination ist aktuell nicht verfügbar.', null, 'error'); return; }
      items = [{ id: v.id, quantity: 1, productId: P.id }];
    }
    if (!items) return;
    addLock = true;
    C.addItems(items).then(function () {
      state.added = true; render();
      setTimeout(function () { state.added = false; addLock = false; render(); }, 1200);
    }, function () { addLock = false; });
  }

  /* ---------- Events im Konfigurator ---------- */
  if (container) {
    container.addEventListener('click', function (e) {
      var t = e.target;
      var b;
      if ((b = t.closest('[data-color]')) && container.contains(b) && !b.disabled) {
        var next = b.getAttribute('data-color');
        if (mode === 'bundle') {
          freezeAutos();
          state.color = next;
          if (state.size && !avail(next, state.size)) state.size = '';
        } else {
          state.color = next;
          state.options[ci] = next;
          if (!currentSingleVariant() || !currentSingleVariant().available) {
            var alt = P.variants.filter(function (v) { return v.available && v.options[ci] === next; })[0];
            if (alt) state.options = alt.options.slice();
          }
        }
        render();
        Gallery.showColor(next);
        return;
      }
      if ((b = t.closest('[data-tier]'))) {
        state.count = Number(b.getAttribute('data-tier'));
        render();
        return;
      }
      if ((b = t.closest('[data-slot-open]'))) { state.open[b.getAttribute('data-slot-open')] = true; render(); return; }
      if ((b = t.closest('[data-slot-done]'))) { delete state.open[b.getAttribute('data-slot-done')]; render(); return; }
      if ((b = t.closest('[data-gift-choice]'))) {
        C.setGiftChoice(b.getAttribute('data-gift-choice'), b.getAttribute('data-variant'));
        render();
        return;
      }
      if ((b = t.closest('[data-option]')) && !b.disabled) {
        state.options[Number(b.getAttribute('data-option'))] = b.getAttribute('data-value');
        render();
        return;
      }
      if (t.closest('[data-add]')) { e.preventDefault(); handleAdd(); return; }
      if (t.closest('[data-open-size-guide]')) { e.preventDefault(); SizeGuide.open(); }
    });

    container.addEventListener('change', function (e) {
      var t = e.target;
      var slotAttr = t.getAttribute('data-slot');
      var slotIdx = slotAttr != null ? Number(slotAttr) : null;
      function slotPatch(patch) {
        var cur = resolveSlot(state.slots[slotIdx]);
        var n = { auto: false, color: cur.color, size: cur.size, band: cur.band, cup: cur.cup, note: '' };
        Object.keys(patch).forEach(function (k) { n[k] = patch[k]; });
        state.slots[slotIdx] = n;
        state.open[slotIdx + 1] = true;
      }
      if (t.hasAttribute('data-slot-color')) {
        slotIdx = Number(t.getAttribute('data-slot-color'));
        var cur = resolveSlot(state.slots[slotIdx]);
        slotPatch({ color: t.value, size: avail(t.value, cur.size) ? cur.size : '' });
      } else if (t.hasAttribute('data-band')) {
        var band = t.value;
        if (slotIdx != null) {
          var s0 = resolveSlot(state.slots[slotIdx]);
          var cup0 = cupsFor(band).indexOf(s0.cup) > -1 ? s0.cup : '';
          var m0 = band && cup0 ? lookup(band, cup0) : null;
          slotPatch({ band: band, cup: cup0, size: m0 && avail(s0.color, m0) ? m0 : (band && cup0 ? s0.size : '') });
        } else {
          var cup = cupsFor(band).indexOf(state.fit.cup) > -1 ? state.fit.cup : '';
          applyTopFit({ band: band, cup: cup });
          var m = band && cup ? lookup(band, cup) : null;
          if (m && avail(state.color, m)) applyTopSize(m, { band: band, cup: cup });
        }
      } else if (t.hasAttribute('data-cup')) {
        var cupV = t.value;
        if (slotIdx != null) {
          var s1 = resolveSlot(state.slots[slotIdx]);
          var m1 = s1.band && cupV ? lookup(s1.band, cupV) : null;
          slotPatch({ cup: cupV, size: m1 && avail(s1.color, m1) ? m1 : '' });
        } else {
          applyTopFit({ band: state.fit.band, cup: cupV });
          var m2 = state.fit.band && cupV ? lookup(state.fit.band, cupV) : null;
          if (m2 && avail(state.color, m2)) applyTopSize(m2, { band: state.fit.band, cup: cupV });
        }
      } else if (t.hasAttribute('data-size-select')) {
        if (slotIdx != null) slotPatch({ size: t.value });
        else applyTopSize(t.value, null);
      } else {
        return;
      }
      render();
    });
  }

  document.addEventListener('voltaire:cart', function (e) {
    var n = (e.detail && e.detail.braCount) || 0;
    if (n !== state.braCountInCart) { state.braCountInCart = n; if (mode === 'bundle') render(); }
  });

  /* ---------- Sticky-Button (mobil) ---------- */
  var sticky = document.querySelector('[data-sticky-buy]');
  var drawerOpen = false;
  function updateSticky() {
    if (!sticky || !container) return;
    var btn = container.querySelector('[data-add]');
    if (!btn) return;
    var visible = btn.getBoundingClientRect().bottom < 72 && !drawerOpen;
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', String(!visible));
    var sb = sticky.querySelector('[data-sticky-add]');
    if (sb) {
      sb.disabled = btn.disabled;
      sb.textContent = btn.textContent;
      sb.tabIndex = visible ? 0 : -1;
    }
  }
  if (sticky) {
    var raf = 0;
    window.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(updateSticky); }, { passive: true });
    window.addEventListener('resize', updateSticky);
    sticky.addEventListener('click', function (e) { if (e.target.closest('[data-sticky-add]')) handleAdd(); });
    document.addEventListener('voltaire:drawer', function (e) { drawerOpen = !!(e.detail && e.detail.open); updateSticky(); });
  }

  /* ---------- Galerie ---------- */
  var Gallery = (function () {
    var wrap = root.querySelector('[data-gallery]');
    var track = wrap && wrap.querySelector('[data-gallery-track]');
    if (!track) return { showColor: function () {} };
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
    var counter = wrap.querySelector('[data-gallery-counter]');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-thumb]'));
    var prev = wrap.querySelector('[data-gallery-prev]');
    var next = wrap.querySelector('[data-gallery-next]');
    var current = 0;

    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function update() {
      current = index();
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current >= slides.length - 1;
      thumbs.forEach(function (t, i) {
        t.setAttribute('aria-current', String(i === current));
        if (i === current && t.parentNode) {
          var p = t.parentNode;
          var left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
          p.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
    }
    var raf2 = 0;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf2); raf2 = requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-gallery-thumb'))); }); });

    // Vollbild
    var box = null;
    function openBox(i) {
      if (!box) {
        box = document.createElement('div');
        box.className = 'lightbox';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', 'Bildansicht');
        box.innerHTML = '<img alt=""><button type="button" class="lightbox__close" aria-label="Schließen">✕</button>' +
          '<button type="button" class="lightbox__nav lightbox__nav--prev" aria-label="Vorheriges Bild">‹</button>' +
          '<button type="button" class="lightbox__nav lightbox__nav--next" aria-label="Nächstes Bild">›</button>';
        document.body.appendChild(box);
        box.addEventListener('click', function (e) {
          if (e.target.closest('.lightbox__prev, .lightbox__nav--prev')) return show(box._i - 1);
          if (e.target.closest('.lightbox__nav--next')) return show(box._i + 1);
          if (e.target === box || e.target.closest('.lightbox__close')) closeBox();
        });
        document.addEventListener('keydown', function (e) {
          if (!box || box.hidden) return;
          if (e.key === 'Escape') closeBox();
          if (e.key === 'ArrowLeft') show(box._i - 1);
          if (e.key === 'ArrowRight') show(box._i + 1);
        });
      }
      box.hidden = false;
      document.body.classList.add('is-locked');
      show(i);
      box.querySelector('.lightbox__close').focus();
    }
    function show(i) {
      i = (i + slides.length) % slides.length;
      box._i = i;
      var img = slides[i].querySelector('img');
      var bi = box.querySelector('img');
      bi.src = img ? (img.currentSrc || img.src) : '';
      bi.alt = img ? img.alt : '';
    }
    function closeBox() { box.hidden = true; document.body.classList.remove('is-locked'); go(box._i, false); }
    slides.forEach(function (s, i) { s.addEventListener('click', function () { openBox(i); }); });

    update();
    return {
      showColor: function (color, instant) {
        var i = slides.findIndex(function (s) { return s.getAttribute('data-color') === color; });
        if (i > -1) go(i, !instant);
      }
    };
  })();

  /* ---------- Größenberater-Dialog ---------- */
  var SizeGuide = (function () {
    var dlg = document.querySelector('[data-size-guide]');
    if (!dlg) return { open: function () { if (DATA.sizeAdvisorUrl) window.location.href = DATA.sizeAdvisorUrl; } };
    var under = dlg.querySelector('[data-guide-under]');
    var over = dlg.querySelector('[data-guide-over]');
    var result = dlg.querySelector('[data-guide-result]');
    var table = dlg.querySelector('[data-guide-table]');
    var BAND_RANGES = [[65, 63, 68.9], [70, 69, 74.9], [75, 75, 79.9], [80, 80, 84.9], [85, 85, 89.9], [90, 90, 94.9], [95, 95, 99.9], [100, 100, 104.9], [105, 105, 109.9]];
    var CUP_RANGES = [['A', 8.5, 11.4], ['B', 11.5, 13.9], ['C', 14, 16.4], ['D', 16.5, 18.9], ['E', 19, 21.5], ['F', 21.6, 23.9]];

    // Tabelle: Größe → passende EU-Größen
    var rows = {};
    bands().forEach(function (b) { cupsFor(b).forEach(function (c) { var s = lookup(b, c); (rows[s] = rows[s] || []).push(b + c); }); });
    var html = '<thead><tr><th scope="col">Größe</th><th scope="col">Passt bei EU-Größe (Umfang + Cup)</th></tr></thead><tbody>';
    P.sizes.forEach(function (s) { if (rows[s]) html += '<tr><td><strong>' + esc(s) + '</strong></td><td>' + esc(rows[s].join(', ')) + '</td></tr>'; });
    html += '</tbody>';
    table.innerHTML = Object.keys(rows).length ? html : '<tbody><tr><td>Für dieses Modell ist keine Tabelle hinterlegt.</td></tr></tbody>';

    function calc() {
      var u = parseFloat(String(under.value).replace(',', '.'));
      var o = parseFloat(String(over.value).replace(',', '.'));
      if (!u || !o || o <= u) { result.hidden = true; return; }
      var band = (BAND_RANGES.filter(function (r) { return u >= r[1] && u <= r[2]; })[0] || [])[0];
      var diff = o - u;
      var cup = (CUP_RANGES.filter(function (r) { return diff >= r[1] && diff <= r[2] + 0.09; })[0] || [])[0];
      var size = band && cup ? lookup(band, cup) : null;
      result.hidden = false;
      if (!size) {
        result.innerHTML = 'Für diese Maße (' + (band ? 'EU ' + band + (cup || '') : 'außerhalb der Tabelle') + ') haben wir keine sichere Empfehlung. Schreiben Sie uns gerne – wir helfen persönlich.';
        return;
      }
      var ok = avail(state.color, size);
      result.innerHTML = '<p>Ihre EU-Größe: ' + band + cup + '</p><p>Empfohlene Größe: <strong>' + esc(size) + '</strong></p>' +
        (ok ? '<button type="button" class="btn btn--dark" style="margin-top:.75rem" data-guide-apply="' + esc(size) + '" data-band="' + band + '" data-cup="' + cup + '">Größe ' + esc(size) + ' übernehmen</button>'
            : '<p class="size-note">Größe ' + esc(size) + ' ist in der gewählten Farbe ausverkauft.</p>');
    }
    under.addEventListener('input', calc);
    over.addEventListener('input', calc);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-close-modal]')) { dlg.close(); return; }
      var apply = e.target.closest('[data-guide-apply]');
      if (apply) {
        var fit = { band: apply.getAttribute('data-band'), cup: apply.getAttribute('data-cup') };
        applyTopFit(fit);
        applyTopSize(apply.getAttribute('data-guide-apply'), fit);
        render();
        dlg.close();
        scrollToField('size-main');
      }
    });
    return { open: function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } };
  })();
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-size-guide]') && !(container && container.contains(e.target))) { e.preventDefault(); SizeGuide.open(); }
  });

  /* ---------- Banner-Countdown (nur mit echtem Enddatum) ---------- */
  (function () {
    var banner = document.querySelector('[data-promo][data-ends-at]');
    if (!banner) return;
    var end = Date.parse(banner.getAttribute('data-ends-at'));
    var timer = banner.querySelector('[data-promo-timer]');
    if (!timer || !isFinite(end)) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left <= 0) { timer.hidden = true; return false; }
      timer.hidden = false;
      timer.querySelector('[data-h]').textContent = pad(Math.floor(left / 3600));
      timer.querySelector('[data-m]').textContent = pad(Math.floor((left % 3600) / 60));
      timer.querySelector('[data-s]').textContent = pad(left % 60);
      return true;
    }
    if (tick()) { var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000); }
  })();

  /* ---------- Kundenvideos ---------- */
  (function () {
    var ugc = document.querySelector('[data-ugc]');
    if (!ugc) return;
    var track = ugc.querySelector('[data-ugc-track]');
    var prev = ugc.querySelector('[data-ugc-prev]');
    var next = ugc.querySelector('[data-ugc-next]');
    function update() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function step(dir) {
      var item = track.querySelector('figure');
      track.scrollBy({ left: dir * (item ? item.offsetWidth + 16 : track.clientWidth * 0.8), behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { rootMargin: '200px' });
      Array.prototype.forEach.call(track.querySelectorAll('video'), function (v) { v.muted = true; io.observe(v); });
    }
  })();

  /* ---------- Start ---------- */
  render();
  if (state.fromUrl && state.color) requestAnimationFrame(function () { Gallery.showColor(state.color, true); });
  if (C) C.get().then(function (cart) {
    state.braCountInCart = C.braCount(cart);
    if (mode === 'bundle' && state.braCountInCart) render();
  }).catch(function () {});
})();
